import { css } from '@emotion/react'
import styled from '@emotion/styled'
import type { SerializedStyles } from '@emotion/utils'
import { memo } from 'react'
import i18n from '../../utilities/i18n'
import IconGroup from '../Icons/Group'
import IconViewers from '../Icons/Viewers'
import { palette } from '../styles/colors'

interface ICounterViewers {
    highContrast?: boolean
    color?: string
    size?: number
    styleOverrides?: SerializedStyles
    viewers?: number
    group?: boolean
    diff?: number
}

const StyledRoot = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
})

const viewersStyle = css({
    flex: 1,
    marginLeft: 3,
    fontSize: 12,
    // fontWeight: 400,
    fontWeight: 500,
    lineHeight: 1,
    color: palette.contrastText,
})

const iconStyles = css({
    flex: '0 0 auto',
    color: palette.contrastIcons,
})
const highContrastStyles = css({
    color: palette.contrastText,
})

const CounterViewers = memo((props: ICounterViewers) => {
    const {
        color,
        highContrast,
        size = 0.8,
        styleOverrides,
        viewers,
        group,
        diff,
    } = props
    const defaultViewersSizeStyle = css({
        fontSize: (12 * size) / 0.8,
    })
    const resolvedStyles = [iconStyles]
    const labelStyles = [viewersStyle, defaultViewersSizeStyle]

    if (highContrast) {
        resolvedStyles.push(highContrastStyles)
    }
    if (styleOverrides) {
        resolvedStyles.push(styleOverrides)
        labelStyles.push(styleOverrides)
    }
    const Icon = group ? IconGroup : IconViewers
    if (typeof viewers !== 'number') return null
    return (
        <StyledRoot title={i18n.t('modelTile.viewers')}>
            <Icon size={size} color={color} css={resolvedStyles} />
            <div data-testid="SearchResultCell__ViewersCount" css={labelStyles}>
                {viewers}
                {diff && <span> +{diff}/min</span>}
            </div>
        </StyledRoot>
    )
})

export default CounterViewers
